// removed by extract-text-webpack-plugin
module.exports = {"title":"_23YFwwvHl1CH8NZBCq2pr","titleLabel":"_1ytPjIOl-BW0eOFsE-vVXj","controls":"_13NEEmUL4ADipEYsnQonKA","cancelBtn":"_29O2ksuLiux90JEtzOrqUU","addBtn":"_3WV6gDArDaHUuhyCrZGFXI","disabled":"k2EPK7CQZNJ3U5s-dazPI","inputLabel":"_3mZipaKH8M0N3LWkJ0cB15","inputContainer":"_3-Fd_fOj1q0HQSbvAjLn6S","sectionTypeContainer":"_32PPkeKoXk_aUcwXXhisPq"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Sections/Sidebar/style/SectionModal.pcss
// module id = 1127
// module chunks = 0